import i18n from '../../../../../base-dictionary';
import type { KeyProcessMeasuresData } from '../../../work-periods.type';

/**
 * Formats the key measures data for the key measures section
 * @param keyMeasuresData - The key measures data to format
 * @returns The formatted key measures data
 */
function formatKeyMeasuresData(keyMeasuresData: KeyProcessMeasuresData | undefined) {
  if (!keyMeasuresData) return [];

  return [
    {
      id: 'strategy',
      name: `${i18n.t('process_analysis.assessment.key_measures.strategy')}`,
      value: keyMeasuresData.strategy != null ? `${keyMeasuresData.strategy}%` : '--',
      description: '% Tied to an epic',
    },
    {
      id: 'complexity',
      name: `${i18n.t('process_analysis.assessment.key_measures.complexity')}`,
      value: keyMeasuresData.complexity != null ? `${keyMeasuresData.complexity}%` : '--',
      description: 'Avg. estimate for pointed tasks',
    },
    {
      id: 'quality',
      name: `${i18n.t('process_analysis.assessment.key_measures.quality')}`,
      value: keyMeasuresData.quality != null ? `${keyMeasuresData.quality}%` : '--',
      description: 'Bugs to share',
    },
    {
      id: 'scope_creep',
      name: `${i18n.t('process_analysis.assessment.key_measures.scope_creep')}`,
      value: keyMeasuresData.scope_creep != null ? `${Number(keyMeasuresData.scope_creep).toFixed(2)}%` : '--',
      description: 'Tasks +/- to plan',
    },
    {
      id: 'readiness',
      name: `${i18n.t('process_analysis.assessment.key_measures.readiness')}`,
      value: keyMeasuresData.readiness != null ? `${keyMeasuresData.readiness}%` : '--',
      description: 'Defined tasks',
    },
    {
      id: 'independence',
      name: `${i18n.t('process_analysis.assessment.key_measures.independence')}`,
      value: keyMeasuresData.independence != null ? `${keyMeasuresData.independence}%` : '--',
      description: 'Tasks with zero dependency',
    },
    {
      id: 'review_time',
      name: `${i18n.t('process_analysis.assessment.key_measures.review_time')}`,
      value: keyMeasuresData.review_time != null ? `${keyMeasuresData.review_time}%` : '--',
      description: 'Avg. days PR is open',
    },
    {
      id: 'declined_change_requests',
      name: `${i18n.t('process_analysis.assessment.key_measures.declined_change_requests')}`,
      value: keyMeasuresData.declined_change_requests != null ? `${keyMeasuresData.declined_change_requests}%` : '--',
      description: 'Declined change requests (%)',
    },
  ];
}

export { formatKeyMeasuresData };
